import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, intlShape, injectIntl } from 'react-intl';
import * as Util from '../../../common/utilities';

import { Button, Modal } from '@salesforce/design-system-react';

import './ExperimentModal.scss';

class DeleteExperimentModal extends Component {
  constructor(props) {
    super(props);
    this.modalName = 'deleteExperiment';
  }

  getI18nID(suffix) {
    return `components.experiment.deleteModal.${suffix}`;
  }

  // ===================================
  // =         Event Handlers          =
  // ===================================
  handleDelete() {
    this.props.actions.deleteExperiment(
      this.props.modals.deleteExperiment.data,
      this.props.context,
      { cToken: this.props.session.experimentCsrfToken }
    );
    this.closeModal();
    if (this.props.context === 'analytics') {
      this.props.history.push('/experiments');
    }
  }

  // ===================================
  // =           Actions               =
  // ===================================
  closeModal() {
    this.props.actions.closeModal(this.modalName);
  }

  // ===================================
  // =        React Lifecycle          =
  // ===================================
  componentDidUpdate(prevProps) {
    const isOpen = 'modals.deleteExperiment.isOpen';

    if (Util.propChanged(prevProps, this.props, isOpen, true)) {
      this.props.actions.getExperiments();
    }
  }

  // ===================================
  // =           Rendering             =
  // ===================================
  renderFooter() {
    const { formatMessage } = this.props.intl;
    /**
     * Cancel
     */
    const cancelLabel = formatMessage({
      id: 'components.experiment.common.cancel'
    });
    const cancelButton = (
      <Button
        label={cancelLabel}
        variant="neutral"
        onClick={this.closeModal.bind(this)}
      />
    );

    /**
     * Save
     */
    const deleteLabel = formatMessage({
      id: this.getI18nID('actionButtons.delete')
    });
    const deleteButton = (
      <Button
        id="experimentDeleteButton"
        label={deleteLabel}
        variant="brand"
        onClick={this.handleDelete.bind(this)}
      />
    );

    return (
      <div className="footer-button-actions">
        <div className="footer-button-actions-right">
          {cancelButton}
          {deleteButton}
        </div>
      </div>
    );
  }

  renderDeleteExperiment() {
    return (
      <div className="slds-card-wrapper">
        <div className="slds-grid">
          <div className="experiment-description">
            <FormattedMessage id={this.getI18nID('description')} />
          </div>
        </div>
      </div>
    );
  }

  renderModal() {
    return this.renderDeleteExperiment();
  }

  render() {
    const { formatMessage } = this.props.intl;
    const isOpen =
      this.props.modals[this.modalName] &&
      this.props.modals[this.modalName].isOpen;
    const modalTitle = formatMessage({
      id: this.getI18nID('title')
    });

    if (!isOpen) {
      return null;
    }

    return (
      <Modal
        heading={modalTitle}
        footer={this.renderFooter()}
        onRequestClose={this.closeModal.bind(this)}
        dismissOnClickOutside={false}
        isOpen={isOpen || false}
      >
        {this.renderModal()}
      </Modal>
    );
  }
}

DeleteExperimentModal.propTypes = {
  actions: PropTypes.object.isRequired,
  context: PropTypes.string,
  history: PropTypes.object,
  modals: PropTypes.object.isRequired,
  flags: PropTypes.object.isRequired,
  intl: intlShape.isRequired,
  session: PropTypes.object
};

export default injectIntl(DeleteExperimentModal);
